import React, { useState } from "react";
import { Row, Col, Button, Modal, Spinner } from "react-bootstrap";
import { Link, useParams, useSearchParams } from "react-router-dom";
import ViewAllUsersHook from "../../hook/admin/ViewAllUsersHook";
import UserGetOrdersHook from "../../hook/user/UserGetOrdersHook";
import mobile from "../../Images/mobile.png";
import { useTranslation } from "react-i18next";
import { getAllOrderByUser, getOneOrder, refundOneItem } from "../../redux/actions/orderAction";
import { useDispatch } from "react-redux";
import notify from "../../hook/useNotification";
import Cookies from "js-cookie";


// refundOneItem
const UserAllOrderCard = ({ item,setLoading,loading }) => {
  const{id}=useParams();

  const[searchParams,setSearchParams]=useSearchParams();

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [users, clickHandler, webSiteData, handleShowFun, showReviews] =
    ViewAllUsersHook();

  const [showModal, setShowModal] = useState(false);
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [description, setDescription] = useState(item?.refundNotes ? item?.refundNotes : "");

  const user = JSON.parse(localStorage.getItem("user"));

 // console.log('id',id);


  const refundOrderItem = async () => {
    try {

      await dispatch(refundOneItem(
        {
          id: item?._id,
          body: {
            refund: "pending",
            refundNotes: description
          }
        }
      ));

notify(t("refund request sent"),"success");
      } catch (error) {
        notify(t("error occurred try again"),"error");

    }
  }

  const refundOrderItemByAdmin=async()=>{
    try {
      await dispatch(refundOneItem(
        {
          id: item?._id,
          body: {
            refund: "accepted",
            orderID:id,
            admin:true,
            addedBy: user?._id
          }
        }
      ));

notify(t("product removed from order"),"success");
      } catch (error) {
        notify(t("error occurred try again"),"error");

    }
  }


  console.log('loading', loading);

  return (
    <div>
      {
        showModal && <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header>
            <Modal.Title>
              <div className="font">{t("من فضلك أدخل سبب الإسترجاع ")}</div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            
            <div className="font">
              <div className="font">
                <textarea
                  id="description"
                  onChange={(e) => setDescription(e.target.value)}
                  value={description}
                  className="input-form-area p-2 mt-2"
                  rows="4"
                  cols="50"
                  placeholder={t("سبب الإسترجاع")}
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="primary"
              className="font"
              onClick={() =>{
                user?.role=='admin' ? refundOrderItemByAdmin() : refundOrderItem()
              } }
            >
              { loading && <Spinner />} {t("Save Changes")}
            </Button>
          </Modal.Footer>
        </Modal>
      }
      <Row className="d-flex mb-3 align-items-center p-3 mx-1 rounded-4 transition-all" style={{ backgroundColor: "#f8f9fc", border: "1px solid rgba(0,0,0,0.04)" }}>
        <Col xs="4" md="2" className="d-flex justify-content-center">
          <Link to={`/product/${item?.product?._id}`} style={{ textDecoration: "none" }}>
            <img
              width="80px"
              height="80px"
              src={(item?.product && item?.product?.image) || mobile}
              alt=""
              style={{ objectFit: "contain", borderRadius: "8px", border: "1px solid #e2e8f0" }}
            />
          </Link>
        </Col>
        <Col xs="8" md="10">
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
            <div className="mb-2 mb-md-0">
              <h6 className="mb-1 fw-bold text-dark" style={{ fontSize: "1.1rem" }}>
                {(item?.product && item?.product?.nameAr) || ""}
              </h6>
              {showReviews && (
                <div className="d-flex align-items-center mb-2" style={{ fontSize: "0.85rem" }}>
                  <span className="text-warning me-1"><i className="fa-solid fa-star"></i> {(item?.product && item?.product?.ratingsAverage) || 0}</span>
                  <span className="text-muted">({(item?.product && item?.product?.ratingsQuantity) || 0} {t("rating")})</span>
                </div>
              )}
              
              <div className="d-flex flex-wrap align-items-center gap-2 mt-2">
                {item?.variant?.title && (
                  <div className="d-flex align-items-center bg-white border rounded-pill px-3 py-1 shadow-sm" style={{ fontSize: "0.85rem" }}>
                    <span className="text-muted me-2" style={{ fontWeight: 600 }}>{t("classification")}:</span>
                    <span className="text-dark fw-bold">
                      {item.variant.title.includes("__::SEPARATOR::__")
                        ? (Cookies.get("i18next") === "ar" ? item.variant.title.split("__::SEPARATOR::__")[1] : item.variant.title.split("__::SEPARATOR::__")[0])
                        : item.variant.title}
                    </span>
                  </div>
                )}

                {item?.product?.weight > 0 && (
                  <div className="d-flex align-items-center bg-white border rounded-pill px-3 py-1 shadow-sm" style={{ fontSize: "0.85rem" }}>
                    <span className="text-muted me-2" style={{ fontWeight: 600 }}>{t("weight")}:</span>
                    <span className="text-dark fw-bold">{(item.product.weight / 1000)} kg</span>
                  </div>
                )}

                <div className="d-flex align-items-center bg-white border rounded-pill px-3 py-1 shadow-sm" style={{ fontSize: "0.85rem" }}>
                  <span className="text-muted me-2" style={{ fontWeight: 600 }}>{t("Color")}:</span>
                  <div 
                    className="rounded-circle" 
                    style={{ 
                      width: "18px", 
                      height: "18px", 
                      backgroundColor: item?.color || 'transparent', 
                      border: (item?.color === '#ffffff' || item?.color === 'white') ? '1px solid #ccc' : '2px solid #fff',
                      boxShadow: '0 0 0 1px #e0e0e0',
                      display: "inline-block"
                    }}
                  ></div>
                </div>
              </div>

              {item.productNotes && (
                <div className="mt-2 text-muted" style={{ fontSize: "0.9rem" }}>
                  <strong>{t("Notes")}:</strong> {item.productNotes}
                </div>
              )}
            </div>

            <div className="d-flex flex-column align-items-start align-items-md-end mt-3 mt-md-0 gap-2">
              <div className="d-flex align-items-center mb-2 mb-md-0">
                <span className="text-muted me-2" style={{ fontSize: "14px", fontWeight: 600 }}>{t("Quantity")}:</span>
                <span className="badge bg-white text-dark shadow-sm border px-3 py-2 rounded-pill" style={{ fontSize: "14px" }}>
                  {item?.quantity}
                </span>
              </div>

              {item?.attachments && item?.attachments !== "" && (
                <button onClick={() => setShowAttachmentModal(true)} className="btn btn-outline-info btn-sm">
                  <i className="fa-solid fa-paperclip me-1"></i> {t("attachments")}
                </button>
              )}

              {user.role === 'user' && item?.refund === '' && (
                <button onClick={() => setShowModal(true)} className="btn-return-modern">
                  {loading && <Spinner size="sm" className="me-1" />} 
                  <i className="fa-solid fa-rotate-left"></i> استرجاع
                </button>
              )}
              {user.role === 'user' && item?.refund === 'pending' && (
                <span className="badge bg-success">تم ارسال طلب استرجاع</span>
              )}
              {user.role === 'admin' && item?.refund === 'pending' && (
                <button onClick={() => setShowModal(true)} className="btn-return-modern">
                  <i className="fa-solid fa-rotate-left"></i> استرجاع
                </button>
              )}
              {item?.refund === 'accepted' && (
                <span className="badge bg-primary">تم قبول طلب الاسترجاع</span>
              )}
            </div>
          </div>
        </Col>
      </Row>

      <Modal show={showAttachmentModal} onHide={() => setShowAttachmentModal(false)} size="lg" centered>
        <Modal.Header>
          <Modal.Title>
            <div className="font">{t("attachments")}</div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex justify-content-center">
          <img
            src={item?.attachments}
            alt={t("attachments")}
            style={{ maxWidth: "100%", maxHeight: "500px", objectFit: "contain" }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            className="font"
            onClick={() => setShowAttachmentModal(false)}
          >
            {t("Close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default UserAllOrderCard;
